<template>
  <div class="contact">
    <div class="columns">
      <div class="is-4 is-offset-2 column">
        <div class="contactbox">
        <p><b>Be More Visible, Inc.</b><br />
        3022 N. Clifton Ave. #1<br />
        Chicago, IL 60657</p>
        <p>312-259-6410</p>
        <p><a href="mailto:info@bemorevisible.com">info@bemorevisible.com</a></p>
        </div>
      </div>
      <div class="is-4 column">
        <bmv-form></bmv-form>
      </div>
    </div>  
  </div>
</template>

<style lang="scss" scoped>
.contact {
  margin:60px auto 160px auto;
}
.contactbox {
  padding:40px;
  background: white;
  box-shadow:8px 8px 0px rgba(0,0,0,0.2);
  font-size:24px;
  a {
    color:black;

  }
  p {
    margin:20px 0px;
  }
  b {
    font-family:'Playfair Display',serif;
  }
}
@media (max-width:400px) {
  .contactbox {
    padding:20px;
    font-size:20px;
  }
}
</style>

<script>
import bmvForm from './Form'


export default {
  name: 'contact',
  components: {
    bmvForm
  }
}


</script>



// WEBPACK FOOTER //
// Contact.vue?710fe484